import React from 'react';

/**
 * Page-level heading block. Mirrors the prototype's `.page-head` / `.eyebrow` /
 * `.page-sub` cluster.
 *
 * <PageHead eyebrow="Overview" title="Welcome back" sub="Last login: ..." />
 */
const PageHead = ({eyebrow, title, sub, className = '', ...rest}) => {
    const cn = ['page-head', className].filter(Boolean).join(' ');
    return (
        <div className={cn} {...rest}>
            {eyebrow && <div className="eyebrow">{eyebrow}</div>}
            <h1>{title}</h1>
            {sub && <div className="page-sub">{sub}</div>}
        </div>
    );
};

export default PageHead;
